import React, { useEffect } from "react";
import useInternetSpeedV2 from "../../../../../hoc/useInternetSpeedV2";

export default function AuctionNetworkMonitorBanner() {
  const { networkStatus, downloadSpeed, isOnline, refreshNetworkSpeed } =
    useInternetSpeedV2();

  const speedDisplay = (() => {
    if (!downloadSpeed) return null;
    const speedInMbps = Number.parseFloat(downloadSpeed);
    if (Number.isNaN(speedInMbps) || speedInMbps < 0) return null;

    const speedInKbps = speedInMbps * 1000;
    return `${Math.round(speedInKbps).toLocaleString("en-IN")} Kbps`;
  })();

  const showUnstableNetworkBanner = [
    "Slow Connection",
    "Very Slow Connection",
    "Error in speed test",
  ].includes(networkStatus);
  const showNetworkAdvisory = isOnline && showUnstableNetworkBanner;

  const advisoryConfig = {
    heading: "Unstable Network Detected",
    body: "Slow internet may delay new bids and auction floor updates. Please move to a better network and use the auction Refresh button within 1 minute to avoid bid or auction data loss.",
    className: "border-[#E0C707] bg-[#FFFBEB]",
    headingClassName: "text-[#B58900]",
  };

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      if (document.hidden) return;
      refreshNetworkSpeed();
    }, 30000);

    return () => window.clearInterval(intervalId);
  }, [refreshNetworkSpeed]);

  return (
    <>
      {showNetworkAdvisory && (
        <div className="fixed left-1/2 -translate-x-1/2 top-12 lg:top-5 z-10 px-2 sm:px-0 font-openSans">
          <div
            className={`w-[95vw] max-w-[640px] rounded-lg border px-3 py-1 sm:px-4 shadow-sm ${advisoryConfig.className}`}
          >
            <div className="flex items-start gap-2.5">
              <div>
                <div
                  className={`text-xs sm:text-sm font-semibold leading-4 ${advisoryConfig.headingClassName}`}
                >
                  {advisoryConfig.heading}
                </div>
                <div className="text-[11px] sm:text-xs leading-4 sm:leading-5 text-brand-textBlack">
                  {advisoryConfig.body}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className={`fixed left-1/2 -translate-x-1/2 z-10 ${
          showNetworkAdvisory ? "top-32 lg:top-28" : "top-5"
        }`}
      >
        <div className="w-[95vw] max-w-[640px] rounded-md border border-brand-textLightGrey bg-white px-3 py-2 text-[11px] text-brand-textBlack shadow-sm">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span>
              <span className="font-semibold">Connection:</span>{" "}
              {isOnline ? "Connected" : "Disconnected"}
            </span>
            <span>
              <span className="font-semibold">Internet:</span> {networkStatus}
            </span>
            <span>
              <span className="font-semibold">Speed:</span>{" "}
              {speedDisplay || "N/A"}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
